import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as WizardClasses from '../WizardClasses'
import { DumbField } from '../Field'
import { TextInput, Select, DateInput } from './Form'
import ReactMarkdown from 'components/Markdown/Markdown'
import { noop } from 'utilities'
import format from 'date-fns/format'

const SIGNATURE_CAPACITY_LABEL = process.env.SIGNATURE_CAPACITY_LABEL

class Signatures extends Component{
  componentWillReceiveProps = nextProps => {
    if(nextProps.multiple && this.props.srcRepeater){
      this.resolveSignatureStructure(nextProps)
    }
  }
  resolveSignatureStructure = nextProps => {
    if(nextProps.multiple){
      const currentRepeaterRows = this.props.srcRepeater.value;
      const incomingRepeaterRows = nextProps.srcRepeater.value;
      const repeaterRowWasDeleted = currentRepeaterRows.length > incomingRepeaterRows.length;
      if(repeaterRowWasDeleted){
        const deletedRowId = this.getDeletedRowId(currentRepeaterRows, incomingRepeaterRows);
        const deletedRowIndex = currentRepeaterRows.findIndex(row => row._rowId === deletedRowId)
        this.deleteValueRowByRowIndex(deletedRowIndex)
      }
    }
  }
  deleteValueRowByRowIndex = deletedRowIndex => {
    const rows = [
      ...this.props.value.slice(0, deletedRowIndex),
      ...this.props.value.slice(deletedRowIndex + 1)
    ]
    this.props.onChange(rows, {})
  }
  getDeletedRowId = (currentRepeaterRows, incomingRepeaterRows) => (
    currentRepeaterRows.filter(row => {
      return incomingRepeaterRows.find(incRow => incRow._rowId === row._rowId) ? false : true
    })[0]._rowId
  )
  setSignatureValueByIndex = (value, index) => {
    let currentValue = this.getValueArray();
    let rows = [
      ...currentValue.slice(0, index),
      value,
      ...currentValue.slice(index + 1)
    ]
    this.props.onChange(rows, {})
  }
  getErrorMessageByIndex = index => {
    const errors = this.getErrors();
    //Only check errors at indexes that are arrays that have been validated
    if(errors == undefined){return "";}
    if(errors.length <=index || errors == ""){return "";}
    if(errors[index].bothValid){return "";}
    else{
      let returnError = []
      returnError.push(errors[index].errorMessage);
      return returnError;
    }
  }
  getErrors = () => {
    if(this.props.errorMessage == "")return "";
    for(let i = 0;i <this.props.errorMessage.length;i++){
      if(Array.isArray(this.props.errorMessage[i])){return this.props.errorMessage[i];
    }
  }
}
  getOuterErrors = () => {
  let errorlist = [];
    for(let i =0; i <this.props.errorMessage.length;i++){
      if(typeof this.props.errorMessage[i] === 'string'){
        errorlist.push(this.props.errorMessage[i]);
        return errorlist;
      }
    }
}
  getValueArray = () => {
    return this.props.srcRepeater.value.map((c, i) => (this.props.value[i] ? this.props.value[i] : {name: '', sig: '', date: process.env.SIGNATURE_DEFAULT_DATE ? format(new Date(), 'MM/dd/yyyy') : null, capacity: '', behalf: ''}))
  }
  setSingleSignature = (value) => {
    this.props.onChange([value], {})
  }
  render(){
    const {
    	srcRepeater,
    	srcField,
    	value,
    	emptyText,
    	description,
    	placeholder,
    	disabled,
    	printMailRequired,
      correctionMode,
    	multiple,
    	required,
      todayButton,
      showCapacity,
      showOnBehalfOf,
      capacityFreeText
    } = this.props
    return(
      <div className="panel signatures">
        {description !== '' && <ReactMarkdown source={description} className='markdown attestation' />}
        <div className='row'>
          {multiple && !showCapacity && <div className='field-label col-sm-3'>Name</div>}
          {showCapacity &&
            <React.Fragment>
              <div className={`field-label col-sm-2`}>
                <span className={`label-text`}>{`${SIGNATURE_CAPACITY_LABEL || "Signer's Capacity"}`}{required && <span className='required'>*</span>}</span>
              </div>
              {
                showOnBehalfOf && (
                  <div className={`field-label col-sm-3`}>
                    <span className={`label-text`}>On behalf of{required && <span className='required'>*</span>}</span>
                  </div>
                )
              }
            </React.Fragment>
          }
          <div className={`field-label col-sm-${showCapacity ? showOnBehalfOf ? '3' : '5' : multiple ? '5' : '7'}`}>
            <span className={`label-text`}>Signature{required && <span className='required'>*</span>}</span>
          </div>
          <div className={`field-label col-sm-${showCapacity ? '3' : multiple ? '4' : '5'}`}>
            <span className={`label-text`}>Date{required && <span className='required'>*</span>}</span>
          </div>
        </div>
        {
          multiple ?
          srcRepeater && srcField ?
            srcRepeater.value.length === 0 ?
                <ReactMarkdown source={emptyText} className='markdown' />
              :
                srcRepeater.value.map((row, i) => (
                  <DumbField errorMessage={this.getErrorMessageByIndex(i)} key={i}>
                    <SignatureRow
                      	label={row[srcField.fieldId]}
                      	disabled={disabled || ((process.env.ALLOW_E_SIGN_ON_CORRECTIONS && correctionMode) ? false : printMailRequired)}
                      	placeholder={placeholder}
                      	onChange={this.setSignatureValueByIndex}
                      	value={process.env.SIGNATURE_DEFAULT_DATE ? {...value[i], date: format(new Date(), 'MM/dd/yyyy')} : value[i]}
                      	srcField={srcField}
                        multiple={multiple}
                        todayButton={todayButton}
                        showCapacity={showCapacity}
                        showOnBehalfOf={showOnBehalfOf}
                        capacityFreeText={capacityFreeText}
                        index={i}
                      />
                  </DumbField>
                ))
            :
              <span className='field-error'>A Source Repeater and Source Field must be selected when requiring multiple signatures.</span>
          :
            <DumbField errorMessage={this.getErrorMessageByIndex(0)}>
              <SignatureRow
                label=''
                disabled={disabled || ((process.env.ALLOW_E_SIGN_ON_CORRECTIONS && correctionMode) ? false : printMailRequired)}
                placeholder={placeholder}
                onChange={this.setSingleSignature}
                value={process.env.SIGNATURE_DEFAULT_DATE ? {...value[0], date: format(new Date(), 'MM/dd/yyyy')} : value[0]}
                multiple={multiple}
                todayButton={todayButton}
                showCapacity={showCapacity}
                showOnBehalfOf={showOnBehalfOf}
                capacityFreeText={capacityFreeText}
                index={0}
              />
            </DumbField>
        }
        {
          this.getOuterErrors() == undefined || (this.getOuterErrors().length == 1 && this.getOuterErrors()[0] === "")
                ? null : <DumbField errorMessage={this.getOuterErrors()}>
                         </DumbField>
        }
      </div>
    )
  }
}
export default connect(
  (state, props) => {
    const srcRepeater = state.wizard.wizard.fields[props.srcRepeater]
    const srcField = srcRepeater ? state.wizard.wizard.fields[props.srcField] : null;
    return {
      srcRepeater,
      srcField,
      printMailRequired: state.wizard.requirePrintMailMethod.size > 0,
      correctionMode: state.wizard.correctionMode
    }
  }
)(Signatures)

class SignatureRow extends Component{
  bubbleValueToParent = sig => {
    const { value = {} } = this.props
    this.props.onChange({...value, sig}, this.props.index)
  }
  bubbleDateToParent = date => {
    const { value = {} } = this.props
    this.props.onChange({...value, date}, this.props.index)
  }
  bubbleByKey = (v, key) => {
    const { value = {} } = this.props
    this.props.onChange({...value, [key]: v, ...(key === 'capacity' && (v === 'self' || v === '') ? {behalf: ''} : {})}, this.props.index)
  }
  render(){
    const { label, value = {}, placeholder, disabled, multiple, todayButton, showCapacity, showOnBehalfOf, capacityFreeText } = this.props;
    value.name = label;
    return(
      <div className='row signature-row'>
        {
          multiple && !showCapacity &&
          <div className='col-sm-3 label'>
            <span>{label}</span>
          </div>
        }
        {
          showCapacity &&
          <div className="col-sm-2">
            {
              capacityFreeText ?
              <TextInput
                disabled={disabled}
                width="100%"
                value={value.capacity}
                onChange={value=>this.bubbleByKey(value, 'capacity')}
                onBlur={noop}
                ariaLabel={SIGNATURE_CAPACITY_LABEL || "Signer's Capacity"}
              />
              :
              <Select
                disabled={disabled}
                value={value.capacity}
                onChange={value=>{this.bubbleByKey(value, "capacity")}}
                onBlur={noop}
                options={[
                  {value: '', label: '[Select an option]'},
                  {value: 'self', label: "Self"},
                  {value: 'power_of_attorney', label: "Power of Attorney"},
                  {value: 'attorney_in_fact', label: "Attorney in Fact"},
                  {value: 'representative', label: "Personal Representative of an Estate"},
                  {value: 'executor', label: "Executor of an Estate"}
                ]}
                ariaLabel={SIGNATURE_CAPACITY_LABEL || "Signer's Capacity"}
              />
            }
          </div>
        }
        {
          showCapacity && showOnBehalfOf &&
          <div className={`col-sm-3 ${multiple ? 'label' : ''}`}>
            {
              multiple ?
              <span>{label}</span>
              :
              <TextInput
              	value={value.behalf}
              	disabled={disabled || (!multiple && (value.capacity === 'self' || value.capacity === undefined || value.capacity === ''))}
              	width="100%"
              	placeholder={placeholder}
              	onChange={v => this.bubbleByKey(v, 'behalf')}
              	onBlur={noop}
                ariaLabel="Signing on behalf of"
              />
            }
          </div>
        }
        <div className={`col-sm-${showCapacity ? showOnBehalfOf ? '3' : '5' : multiple ? '5' : '7'}`}>
          <TextInput
          	value={value.sig}
          	disabled={disabled}
          	width="100%"
          	placeholder={placeholder}
          	onChange={this.bubbleValueToParent}
          	onBlur={noop}
            ariaLabel={multiple ? `Signature for ${label}` : "Signature"}
          />
        </div>
        <div className={`col-sm-${showCapacity ? '4' : multiple ? '4' : '5'}`}>
          <DateInput value={value.date} disabled={disabled || process.env.DISALLOW_SIGNATURE_DATE_CHANGE} todayButton={process.env.DISALLOW_SIGNATURE_DATE_CHANGE ? null : todayButton} onChange={this.bubbleDateToParent} onBlur={noop} />
        </div>
      </div>
    )
  }
}
SignatureRow = connect(
  (state, props) => {
    let label = props.multiple ? new WizardClasses[props.srcField.fieldClass]().getHumanReadableValue(props.srcField, props.label) : '';
    if(props.multiple && props.srcField.fieldClass === 'NameQualifiedOrg'){
      label = new WizardClasses[props.srcField.fieldClass]().getHumanReadableSignatureValue(props.srcField, props.label)
    }
    return ({ label })
  }
)(SignatureRow)


// WEBPACK FOOTER //
// ./src/components/Wizard2/fieldComponents/Signatures.js